<template>
  <div class="content">
    <div class="page-inner">
      <h1 class="h4 page-title mb-4">{{ $t('promotion_services') }}</h1>

      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <img src="/static/img/services/spotify.jpg" alt="Spotify Campaign" class="img-fluid">
              </div>
              <div class="col-9">
                <h2 class="mt-0 font-weight-bold mb-2 text-dark">Spotify Growth Campaign <span class="badge badge-primary ml-1 mt--1">NEW <i class="fa fa-fire text-warning ml-1"></i></span> </h2>
                <p class="small mt--2 mb-2">
                  <i class="fab fa-spotify text-success mr-1"></i> Spotify
                </p>
                <p class="text-muted mb-0 mb-3">
                  {{ $t('spotify_growth_description') }} <a target="_blank" href="https://indiefy.net/blog/how-to-increase-your-monthly-listeners-on-spotify">How to Increase Your Monthly Listeners on Spotify</a>
                </p>
                <h3 class="text-dark font-weight-bold my-2">
                  $250 USD
                </h3>
              </div>
            </div>
            <div class="div mt-3 text-right">
              <router-link to="/services/spotify-growth" class="btn btn-success">
                <i class="fa fa-star mr-2"></i> {{ $t('start_campaign') }}
              </router-link>
            </div>
          </div>
        </div>

        <div class="card" v-if="false">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <img src="/static/img/services/superstar.jpg" alt="Superstar Campaign" class="img-fluid">
              </div>
              <div class="col-9">
                <h2 class="mt-0 font-weight-bold mb-2 text-dark">Superstar Campaign <span class="badge badge-danger ml-1 mt--1">HOT <i class="fa fa-fire ml-1"></i></span> </h2>
                <p class="small mt--2 mb-2">
                  <i class="fab fa-spotify text-success mr-1"></i> Spotify
                </p>
                <p class="text-muted mb-0 mb-3">
                  {{ $t('superstar_description') }}
                </p>
                <h4 class="text-muted font-weight-bold my-2 line-through mb-0">
                  ${{ (fullCampaignCost + (fullCampaignCost * 0.4) + '').split('.')[0] }}.<span>99</span> USD
                </h4>
                <h3 class="text-dark font-weight-bold my-2">
                  ${{ (fullCampaignCost + '').split('.')[0] }}.<span>99</span> USD
                </h3>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6 pr-1">
                <button type="button" class="btn btn-default btn-block" :class="{ 'btn-primary disabled': selectedPackage === 'Superstar Campaign' }" @click="toggleBasicCard('Superstar Campaign')">
                  <i class="fa fa-credit-card mr-1"></i> Credit Card
                </button>
              </div>
              <div class="col-6 pl-1">
                <div id="playlist_star"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="false">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <img src="/static/img/services/master.jpg" alt="Playlist Master Campaign" class="img-fluid">
              </div>
              <div class="col-9">
                <h2 class="mt-0 font-weight-bold mb-2 text-dark">Playlist Master <span class="badge badge-danger ml-1 mt--1">HOT <i class="fa fa-fire ml-1"></i></span> </h2>
                <p class="small mt--2 mb-2">
                  <i class="fab fa-spotify text-success mr-1"></i> Spotify
                </p>
                <p class="text-muted mb-0 mb-3">
                  {{ $t('playlist_master_description') }}
                </p>
                <h4 class="text-muted font-weight-bold my-2 line-through">
                  ${{ (placementMasterCost + (placementMasterCost * 0.4) + '').split('.')[0] }}.<span>99</span> USD
                </h4>
                <h3 class="text-dark font-weight-bold my-2">
                  ${{ (placementMasterCost + '').split('.')[0] }}.<span>99</span> USD
                </h3>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6 pr-1">
                <button type="button" class="btn btn-default btn-block" :class="{ 'btn-primary disabled': selectedPackage === 'Playlist Master' }" @click="toggleBasicCard('Playlist Master')">
                  <i class="fa fa-credit-card mr-1"></i> Credit Card
                </button>
              </div>
              <div class="col-6 pl-1">
                <div id="playlist_master"></div>
              </div>
            </div>
            <!-- <div class="mt-3 text-center">
              <div class="alert alert-warning mt-3" role="alert">
                <i class="fas fa-exclamation-triangle text-warning"></i> {{ $t('temporarily_unavailable') }}
              </div>
            </div> -->
          </div>
        </div>

        <div class="card" v-if="false">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <img src="/static/img/services/basic.jpg" alt="Playlist Placement Basic" class="img-fluid">
              </div>
              <div class="col-9">
                <h2 class="mt-0 font-weight-bold mb-2 text-dark">Playlist Basic (Spotify)</h2>
                <p class="small mt--2 mb-2">
                  <i class="fab fa-spotify text-success mr-1"></i> Spotify
                </p>
                <p class="text-muted mb-0 mb-3">
                  {{ $t('playlist_basic_description') }}
                </p>
                <h3 class="text-dark font-weight-bold my-2">
                  ${{ (placementBasicCost + '').split('.')[0] }}.<span>99</span> USD
                </h3>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-6 pr-1">
                <button type="button" class="btn btn-default btn-block" :class="{ 'btn-primary disabled': selectedPackage === 'Playlist Basic' }" @click="toggleBasicCard('Playlist Basic')">
                  <i class="fa fa-credit-card mr-1"></i> Credit Card
                </button>
              </div>
              <div class="col-6 pl-1">
                <div id="playlist_basic"></div>
              </div>
            </div>
            <!-- <div class="mt-3 text-center">
              <div class="alert alert-warning mt-3" role="alert">
                <i class="fas fa-exclamation-triangle text-warning"></i> {{ $t('temporarily_unavailable') }}
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div v-show="showCardBasic" class="animated fadeInUp" ref="cardContainer">
        <h4 class="page-title mt-4">Pay with Credit Card ({{ selectedPackage }})</h4>
        <div class="mt-3 card">
          <div class="card-body">
            <input class="form-control" v-model="name" type="text" :placeholder="$t('cardholder_name')">
            <input type="text" v-model="address" class="form-control mt-1" :placeholder="$t('billing_address')">
            <div ref="card"></div>
            <div class="pull-right">
              <img src="/static/img/upgrade/powered_by_stripe.png" alt="Playlist Placement, Payment by Stripe" width="70">
            </div>
            <button type="button" class="btn btn-success mt-2" @click="pay()" :disabled="subscribing">
              <i v-if="subscribing" class="fa fa-spinner fa-spin"></i>
              <span v-if="!subscribing">{{ $t('confirm') }}</span>
            </button>
          </div>
        </div>
      </div>

      <h4 class="page-title mt-4">Reviews</h4>
      <div class="row mt-2">
        <div class="col-md-4">
          <div class="card card-post card-round">
            <div class="card-body">
              <div class="d-flex">
                <div class="avatar">
                  <img src="https://assets.indiefy.net/artist-images/1563298086624.jpg" alt="Head Twister" class="avatar-img rounded-circle">
                </div>
                <div class="info-post ml-2">
                  <a href="https://indiefy.me/head-twister" rel="ugc noopener noreferrer" target="_blank" class="username">Head Twister</a>
                  <p class="date text-muted">Mexico / 15 Feb 19</p>
                </div>
              </div>
              <div class="separator-solid"></div>
              <p class="card-category text-info mb-1">
                <a href="javascript:void(0)">Playlist Master</a>
              </p>
              <p class="card-text">
                "My streams have been increased since I added my track "Pump It Up" to playlists, now I am getting new organic listeners because my music appears in the Spotify playlists."
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card card-post card-round">
            <div class="card-body">
              <div class="d-flex">
                <div class="avatar">
                  <img src="https://assets.indiefy.net/artist-images/5be48e0bdfc10b480425605b.png" alt="Javzye" class="avatar-img rounded-circle">
                </div>
                <div class="info-post ml-2">
                  <a href="https://indiefy.me/javzye" target="_blank" rel="ugc noopener noreferrer" class="username">Javzye</a>
                  <p class="date text-muted">Brazil / 21 May 19</p>
                </div>
              </div>
              <div class="separator-solid"></div>
              <p class="card-category text-info mb-1">
                <a href="javascript:void(0)">Playlist Basic</a>
              </p>
              <p class="card-text">
                "Este es de los otros El servicio de Playlisting esta bien, esta es la segunda vez que lo utilizo pero creo que no lo utilizaré mas por el momento, al ser 60k y solo tener unas 755 personas de escuchas y 90k y tener unas 200 la primea vez, la segunda vez no me metieron en la playlist que mas personas la utilizaban, adjunto mis estadísticas."
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="card card-post card-round">
            <div class="card-body">
              <div class="d-flex">
                <div class="avatar">
                  <img src="https://i1.sndcdn.com/avatars-000563547432-l4rjws-t500x500.jpg" alt="Love Kr3w" class="avatar-img rounded-circle" onerror="this.src = '/static/img/img-placeholder.jpg'">
                </div>
                <div class="info-post ml-2">
                  <a href="https://open.spotify.com/artist/2pAMGFyy8r9uOe1rVYCPpj?si=NbkrYktBS8uC7PZA3XRLSQ" rel="ugc noopener noreferrer" target="_blank" class="username">Love Kr3w</a>
                  <p class="date text-muted">Spain / 30 Jun 19</p>
                </div>
              </div>
              <div class="separator-solid"></div>
              <p class="card-category text-info mb-1">
                <a href="javascript:void(0)">Playlist Master</a>
              </p>
              <p class="card-text">
                "All things worked very well, thank you. We can highly recommend your service. The only thing we have to say is that the tracks may should stay like 10-14 days instead of just one week in the big 90.000 follower playlists. But that's just a suggestion from our site, it's not meant to be understand as criticism 🙂.<br/><br/>
                Thank you again and we will send you some more submissions in future for sure. Especially if the price will be the same in the future as it is currently!"
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import User from '../services/user'
import Select2 from './utils/Select2'
import Services from '../services/services'
import countries from '../data/countries'
import _ from 'underscore'

export default {
  name: 'Services',
  data: function () {
    return {
      name: '',
      country: '',
      address: '',
      subscribing: false,
      countries: _.map(countries, (country) => { return { text: country.name, id: country.name } }),
      selectedPackage: '',
      showCardBasic: false,
      placementBasicCost: 14.16,
      placementMasterCost: 34.16,
      fullCampaignCost: 67.99,
      purchasedService: null,
      user: {}
    }
  },
  methods: {
    pay: function () {
      if (!this.user._id) {
        return this.$router.push('/login?next=/services')
      }

      if (!this.name) {
        return this.$notify({ message: this.$t('cardholder_required') }, 'warning', 'fa-exclamation')
      }

      if (!this.country) {
        return this.$notify({ message: this.$t('country_required') }, 'warning', 'fa-exclamation')
      }

      if (!this.address) {
        return this.$notify({ message: this.$t('address_required') }, 'warning', 'fa-exclamation')
      }

      this.subscribing = true
      this.stripe.createToken(this.card).then(data => {
        if (data.error) {
          this.subscribing = false
          if (data.error.code === 'incomplete_cvc') {
            this.$notify({ message: this.$t('incomplete_cvc') }, 'warning', 'fa-exclamation')
          }

          if (data.error.code === 'incomplete_zip') {
            this.$notify({ message: this.$t('incomplete_zip') }, 'warning', 'fa-exclamation')
          }
        } else {
          User.purchaseService({ data: data, name: this.name, address: this.address, package: this.selectedPackage, token: data.token.id }).then(response => {
            if (!response.data._id) {
              console.error(response.data)
              return this.$notify({ message: 'We have found an error, please contact support' }, 'warning', 'fa-exclamation')
            }

            Services.save({ transaction: response.data._id, user: this.user, service: response.data.transactions[0].custom, paid: 1 }).then(response => {
              this.purchasedService = response.data
              this.subscribing = false
              this.$notify({ message: this.$t('request_received') }, 'success', 'fa-check')

              this.trackPurchase()
              this.$router.push('/user/services')
            })
          }).catch(error => {
            this.subscribing = false
            console.error(error.response)

            if (error.response.code === 'card_declined') {
              this.$notify({ message: this.$t('card_declined') }, 'warning', 'fa-exclamation')
            } else {
              this.$notify({ message: this.$t('subscribe_payment_error') }, 'warning', 'fa-exclamation')
            }
          })
        }
      })
    },
    initStripe: function () {
      let stripeKey = 'pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm'

      if (window.location.href.match(/localhost|development|staging/)) {
        stripeKey = 'pk_test_WD9FBh5jNgV5uO1eFQBkLdAl000Ey6vyno'
      }

      this.stripe = window.Stripe(stripeKey)
      let elements = this.stripe.elements()
      this.card = elements.create('card')
      this.card.mount(this.$refs.card)
    },
    toggleBasicCard: function (selectedPackage) {
      if (!this.user._id) {
        return this.$router.push('/login?next=/services')
      }

      this.selectedPackage = selectedPackage
      this.showCardBasic = true
      this.$forceUpdate()

      setTimeout(() => {
        window.$('html, body').animate({
          scrollTop: window.$(this.$refs.cardContainer).offset().top - 150
        }, 1000)
      }, 500)
    },
    askForLink: function (service) {
      window.swal({
        closeOnClickOutside: false,
        closeOnEsc: false,
        title: this.$t('provide_spotify_link'),
        content: {
          element: 'input',
          attributes: {
            placeholder: 'https://open.spotify.com/track/5l6yhYGGIqhZEFZVHMrgVz',
            type: 'url',
            id: 'spotify-link',
            className: 'form-control'
          }
        },
        buttons: {
          cancel: {
            className: 'btn',
            text: this.$t('send_later'),
            visible: true
          },
          confirm: {
            text: this.$t('send'),
            className: 'btn btn-success'
          }
        }
      }).then((confirm) => {
        if (confirm) {
          if (!window.$('#spotify-link').val()) {
            return this.askForLink(service)
          }

          if (!window.$('#spotify-link').val().match(/\/track/)) {
            this.$notify({ message: this.$t('invalid_spotify_url') }, 'warning', 'fa-exclamation')

            return setTimeout(() => {
              this.askForLink(service)
            }, 2000)
          }

          this.purchasedService.log.push({
            date: new Date().toISOString(),
            message: `Spotify URL: ${window.$('#spotify-link').val()}`
          })

          Services.save(this.purchasedService).then(response => {
            this.$notify({ message: this.$t('request_received') }, 'success', 'fa-check')
            this.$router.push('/user/services')
          })
        } else {
          this.$notify({ message: this.$t('request_received') }, 'success', 'fa-check')
          this.$router.push('/user/services')
        }
      })
    },
    trackPurchase: function () {
      window.twttr && window.twttr.conversion.trackPid('o2s5d', { tw_sale_amount: 0.01, tw_order_quantity: 1 })
      window.ga && window.ga('send', 'pageview', '/service-purchase')

      if (this.selectedPackage === 'Playlist Basic' || this.selectedPackage === 'Playlist Basic Apple') {
        window.twttr && window.twttr.conversion.trackPid('o2s4g', { tw_sale_amount: this.placementBasicCost, tw_order_quantity: 1 })
        window.fbq && window.fbq('track', 'Purchase', { value: this.placementBasicCost, currency: 'USD' })
        window.gtag && window.gtag('event', 'purchase', {
          'transaction_id': new Date().getTime() + '',
          'value': this.placementBasicCost,
          'currency': 'USD',
          'tax': 1.3,
          'shipping': 0,
          'items': [
            {
              'id': 'playlist_basic',
              'name': this.selectedPackage,
              'category': 'Playlist Promotion',
              'quantity': 1,
              'price': this.placementBasicCost
            }
          ]
        })
      } else if (this.selectedPackage === 'Playlist Master') {
        window.twttr && window.twttr.conversion.trackPid('o2s4h', { tw_sale_amount: this.placementMasterCost, tw_order_quantity: 1 })
        window.fbq && window.fbq('track', 'Purchase', { value: this.placementMasterCost, currency: 'USD' })
        window.gtag && window.gtag('event', 'purchase', {
          'transaction_id': new Date().getTime() + '',
          'value': this.placementMasterCost,
          'currency': 'USD',
          'tax': 1.3,
          'shipping': 0,
          'items': [
            {
              'id': 'playlist_master',
              'name': this.selectedPackage,
              'category': 'Playlist Promotion',
              'quantity': 1,
              'price': this.placementMasterCost
            }
          ]
        })
      } else if (this.selectedPackage === 'Superstar Campaign') {
        window.twttr && window.twttr.conversion.trackPid('o2s4i', { tw_sale_amount: this.fullCampaignCost, tw_order_quantity: 1 })
        window.fbq && window.fbq('track', 'Purchase', { value: this.fullCampaignCost, currency: 'USD' })
        window.gtag && window.gtag('event', 'purchase', {
          'transaction_id': new Date().getTime() + '',
          'value': this.fullCampaignCost,
          'currency': 'USD',
          'tax': 1.3,
          'shipping': 0,
          'items': [
            {
              'id': 'playlist_superstar',
              'name': this.selectedPackage,
              'category': 'Playlist Promotion',
              'quantity': 1,
              'price': this.fullCampaignCost
            }
          ]
        })
      }
    },
    purchaseSuccess: function (result) {
      let user = this.$user._id

      if (result.transactions) {
        const data = result
        data.user_id = user

        User.registerService(data).then(response => {
          Services.save({ transaction: response.data._id, user, service: result.transactions[0].custom, paid: 1 }).then(response => {
            console.log('Service sent successfully')
            this.purchasedService = response.data
          }).catch(() => {
            console.error('Error when trying to save service, please contact support')
          })

          if (result.transactions[0] && result.transactions[0].amount && !location.href.match(/localhost/)) {
            this.trackPurchase()
          }

          if (result.transactions[0] && result.transactions[0].custom !== 'playlist_placement_campaign') {
            this.askForLink(result.transactions[0].custom)
          } else {
            window.swal({
              title: this.$t('done_exclamation'),
              text: this.$t('request_received'),
              className: 'icon-modal',
              icon: 'success',
              buttons: {
                confirm: {
                  className: 'btn btn-success'
                }
              }
            })
          }
        })
      }
    },
    renderButtons: function () {
      let environment = 'production'
      let lang = 'en_US'

      if (location.host.match(/localhost|development|staging/)) {
        environment = 'sandbox'
      }

      if (window.navigator.language.match(/es/)) {
        lang = 'es_ES'
      }

      window.paypal.Button.render({
        env: environment, // Or 'production or sandbox',
        client: {
          production: 'Ac4lOtfFJuDY-dNuAJE4enid-k0VMlZT3lrWq2YbziGfh80MGP9TH2obduq_OuRPuNHnx0WVJPupUP1q',
          sandbox: 'AawfM9czZeZD6nUgcj_ycXFuZCRQSBdKMuQd-1Sxd5kKYhd0FfkKSdJx_mggQr7rB1wOV_NFghulJ0ME'
        },
        locale: lang,
        funding: {
          disallowed: [window.paypal.FUNDING.CREDIT]
        },
        style: {
          tagline: 'false',
          color: 'black',
          fundingicons: 'false',
          shape: 'rect',
          height: 43,
          size: 'responsive'
        },
        payment: (data, actions) => {
          return actions.payment.create({
            transactions: [{
              custom: 'playlist_placement',
              amount: {
                total: this.placementBasicCost.toFixed(2),
                currency: 'USD'
              }
            }]
          })
        },
        onAuthorize: (data, actions) => {
          return actions.payment.execute()
            .then(response => this.purchaseSuccess(response))
        },
        onCancel: (data, actions) => {
          // return actions.redirect()
        },
        onError: (error) => {
          console.error('Paypal not success purchase', error)
        },
        onClick: () => {
          if (!this.user._id) {
            return this.$router.push('/login?next=/services')
          }
        }
      }, '#playlist_basic')

      window.paypal.Button.render({
        env: environment, // Or 'production or sandbox',
        client: {
          production: 'Ac4lOtfFJuDY-dNuAJE4enid-k0VMlZT3lrWq2YbziGfh80MGP9TH2obduq_OuRPuNHnx0WVJPupUP1q',
          sandbox: 'AawfM9czZeZD6nUgcj_ycXFuZCRQSBdKMuQd-1Sxd5kKYhd0FfkKSdJx_mggQr7rB1wOV_NFghulJ0ME'
        },
        locale: lang,
        funding: {
          disallowed: [window.paypal.FUNDING.CREDIT]
        },
        style: {
          tagline: 'false',
          color: 'black',
          fundingicons: 'false',
          shape: 'rect',
          height: 43,
          size: 'responsive'
        },
        payment: (data, actions) => {
          return actions.payment.create({
            transactions: [{
              custom: 'playlist_placement_master',
              amount: {
                total: this.placementMasterCost.toFixed(2),
                currency: 'USD'
              }
            }]
          })
        },
        onAuthorize: (data, actions) => {
          return actions.payment.execute()
            .then(response => this.purchaseSuccess(response))
        },
        onCancel: (data, actions) => {
          // return actions.redirect()
        },
        onError: (error) => {
          console.error('Paypal not success purchase', error)
        },
        onClick: () => {
          if (!this.user._id) {
            return this.$router.push('/login?next=/services')
          }
        }
      }, '#playlist_master')

      window.paypal.Button.render({
        env: environment, // Or 'production or sandbox',
        client: {
          production: 'Ac4lOtfFJuDY-dNuAJE4enid-k0VMlZT3lrWq2YbziGfh80MGP9TH2obduq_OuRPuNHnx0WVJPupUP1q',
          sandbox: 'AawfM9czZeZD6nUgcj_ycXFuZCRQSBdKMuQd-1Sxd5kKYhd0FfkKSdJx_mggQr7rB1wOV_NFghulJ0ME'
        },
        locale: lang,
        funding: {
          disallowed: [window.paypal.FUNDING.CREDIT]
        },
        style: {
          tagline: 'false',
          color: 'black',
          fundingicons: 'false',
          shape: 'rect',
          height: 43,
          size: 'responsive'
        },
        payment: (data, actions) => {
          return actions.payment.create({
            transactions: [{
              custom: 'playlist_placement_campaign',
              amount: {
                total: this.fullCampaignCost.toFixed(2),
                currency: 'USD'
              }
            }]
          })
        },
        onAuthorize: (data, actions) => {
          return actions.payment.execute()
            .then(response => this.purchaseSuccess(response))
        },
        onCancel: (data, actions) => {
          // return actions.redirect()
        },
        onError: (error) => {
          console.error('Paypal not success purchase', error)
        },
        onClick: () => {
          if (!this.user._id) {
            return this.$router.push('/login?next=/services')
          }
        }
      }, '#playlist_star')
    }
  },
  mounted: function () {
    this.initStripe()
    this.renderButtons()

    setTimeout(() => {
      window.prerenderReady = true

      window.$('html, body').animate({
        scrollTop: 0
      }, 500)
    }, 100)
    setTimeout(() => {
      this.$router.push('/dashboard')
    }, 500)
  },
  created: function () {
    this.user = this.$user

    if (this.user && this.user.country) {
      let country = _.find(countries, country => country.code === this.user.country)

      if (country) {
        this.country = country.name
      }
    }

    window.document.title = this.$t('services_title') + ' | Indiefy'
    window.$('meta[name="description"]').attr('content', this.$t('services_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('services_description'))
  },
  components: {
    Select2
  }
}
</script>
<style lang="scss" scoped>
.StripeElement {
  margin-top: 4px;
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid #ebedf2;
  border-radius: 4px;
  background-color: white;
  margin-bottom: 10px;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.StripeElement.complete {
  border: 2px solid green;
}

.line-through {
  font-size: 12px;
}

.list-group-item {
  display: block !important;
}

.card img {
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Services.vue